// The management-page header: a mono eyebrow, the title, and optional
// right-aligned actions. Keeps the pages visually consistent with the shell.

import type { ReactNode } from "react";

export function PageHeader({
  eyebrow,
  title,
  actions,
}: {
  eyebrow: string;
  title: string;
  actions?: ReactNode;
}) {
  return (
    <div className="flex items-end justify-between gap-4">
      <div className="flex flex-col gap-1">
        <span className="font-mono text-xs tracking-wider text-muted-foreground uppercase">
          {eyebrow}
        </span>
        <h2 className="text-2xl font-semibold tracking-tight">{title}</h2>
      </div>
      {actions}
    </div>
  );
}
